import parse from "html-react-parser";

type AccordionContentItem = {
  tr_text: string;
  icon: string | null;
};

type AccordionItem = {
  tr_title: string;
  content_type: "list" | "text";
  content_list: AccordionContentItem[];
  tr_content_text: string;
};

type DrawerProps = {
  tr_heading: string;
  tr_description: string;
  facts_accordion: AccordionItem[];
  section_image: string | null;
};

export const Drawer = ({
  tr_heading,
  tr_description,
  facts_accordion,
  section_image,
}: DrawerProps) => (
  <>
    <h2 className="formula-title content-wide section-heading">
      {parse(tr_heading)}
    </h2>

    <div className="section-subtitle content-wide">{parse(tr_description)}</div>

    <div className="split-layout content-wide">
      <div className="content-left">
        <section className="formula-section">
          <div className="formula-faq">
            {facts_accordion.map((item, idx) => (
              <details key={idx} className="faq-item" open={idx === 0}>
                <summary className="faq-question">
                  <span>{parse(item.tr_title)}</span>
                  <div className="faq-icon" />
                </summary>

                <div className="faq-answer">
                  {item.content_type === "list" ? (
                    <div className="benefit-list">
                      {item.content_list.map((contentItem, i) => (
                        <div className="benefit-item-faq" key={i}>
                          {contentItem.icon && (
                            <div className="benefit-icon-faq">
                              <img src={contentItem.icon} alt="" />
                            </div>
                          )}
                          <div>{parse(contentItem.tr_text)}</div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div>{parse(item.tr_content_text)}</div>
                  )}
                </div>
              </details>
            ))}
          </div>
        </section>
      </div>

      {section_image && (
        <div className="content-right">
          <div className="formula-image-container">
            <img src={section_image} alt="" className="formula-image" />
          </div>
        </div>
      )}
    </div>
  </>
);
